export default function Footer() {
  return (
    <footer className="text-center p-14 bg-[#1B0063] dark:bg-[#1B0063] text-sm text-white dark:text-white">
      © 2026 NCCF India. All rights reserved.
    </footer>
  );
}
